import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { IUser, IUserResponse } from "../../interfaces/auth.interface";

interface AuthState {
  user: IUser | null;
  token: string | null;
}

const initialState: AuthState = {
  user: null,
  token: localStorage.getItem("token"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUserResponse>) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    setMe: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
      if (action.payload) {
        localStorage.setItem("token", action.payload);
      } else {
        localStorage.removeItem("token");
      }
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("verifyToken");
    },
    setUserSubscriptionStatus: (state, action: PayloadAction<string>) => {
      if (!state.user) return;
      state.user.subscriptionStatus = action.payload;
    },
  },
});

export const { logout, setUser, setUserSubscriptionStatus, setMe, setToken } =
  authSlice.actions;
export default authSlice.reducer;
